import {get} from "../../middleware/api-proxy";

export class CategoriesService {
  
  static async getCategories() {
    return await get("/root-data/categories")
  }
}